/* istanbul ignore file */

import type { CheckboxesInputModel, DateRangeInputModel, RadioButtonsInputModel } from '@libs/form/models';
import type { RadioButtonsOptionModel } from '@libs/shared/models';
import type { DateTime } from 'luxon';

export type OrderHistoryItemAvailabilityType = 'available' | 'limited' | 'unavailable';
export type OrderHistoryItemSortByValueType = 'name' | '-name' | 'position';

export interface OrderHistoryRecordFilter {
  categoryIds: string[];
  availability?: OrderHistoryItemAvailabilityType;
  delivery?: {
    from?: DateTime;
    to?: DateTime;
  };
}

export const OrderHistoryItemAvailabilityOptions: RadioButtonsOptionModel[] = [
  { value: '', label: 'Alle' },
  { value: 'available', label: 'verfügbar' },
  { value: 'limited', label: 'begrenzt verfügbar' },
  { value: 'unavailable', label: 'nicht verfügbar' },
];

export const OrderHistoryItemAvailability: RadioButtonsInputModel = {
  type: 'radioButtons',
  name: 'availability',
  label: 'Artikelverfügbarkeit',
  defaultValue: '',
  value: '',
  options: OrderHistoryItemAvailabilityOptions,
};

export const OrderHistoryItemDeliveryDate: DateRangeInputModel = {
  type: 'dateRange',
  name: 'deliveryDate',
  label: 'Lieferdatum',
  subscriptSizing: 'dynamic',
  value: {
    start: null,
    end: null,
  },
  defaultValue: {
    start: null,
    end: null,
  },
};

export const OrderHistoryItemSortByOptions: RadioButtonsOptionModel[] = [
  { value: 'position', label: 'Position' },
  { value: 'name', label: 'Artikelname A-Z' },
  { value: '-name', label: 'Artikelname Z-A' },
];

export const OrderHistoryItemSortBy: RadioButtonsInputModel = {
  type: 'radioButtons',
  name: 'sort',
  label: 'Sortierung',
  defaultValue: 'position',
  value: 'position',
  options: OrderHistoryItemSortByOptions,
};

export const OrderHistoryItemAssortment: CheckboxesInputModel = {
  type: 'checkboxes',
  name: 'assortment',
  label: 'Sortiment',
  defaultValue: {},
  options: [],
};
